import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { RULE_STRING_FUNCTION_TYPES } from 'yeself-common/enum/RuleEnum';

import SelectField from '../../components/SelectField';
import PlainStringField from '../../components/PlainStringField';

import { UserAttributeRuleValues } from '../types';

type UserAttributeRuleFieldProps = {
    value: UserAttributeRuleValues;
    onChange: (value: UserAttributeRuleValues) => void;
    options: { value: string; label: string }[];
};

const UserAttributeRuleField = ({
    value,
    onChange,
    options = [],
}: UserAttributeRuleFieldProps): React.ReactElement => {
    const [levelValue, setLevelValue] = useState({
        level0: value.level?.[0]?.data.value.value || null,
        level1: value.level?.[1]?.data.key || null,
        level2: value.level?.[2]?.data.value || null,
    });

    const handleOnChange = useCallback(
        (index: number) => (newValue) => {
            const newLevelValue = { ...levelValue, [`level${index}`]: newValue };

            const level: UserAttributeRuleFieldProps['value']['level'] = [
                newLevelValue.level0
                    ? { data: { value: { value: newLevelValue.level0, label: '' } } }
                    : undefined,
                newLevelValue.level1 ? { data: { key: newLevelValue.level1 } } : undefined,
                newLevelValue.level2 ? { data: { value: newLevelValue.level2 } } : undefined,
            ];

            setLevelValue(newLevelValue);
            onChange({ ...value, level });
        },
        [levelValue, onChange, value]
    );

    return (
        <>
            <SelectField
                autoWidth
                options={options}
                value={levelValue.level0 || ''}
                onChange={handleOnChange(0)}
            />
            {levelValue.level0 ? (
                <SelectField
                    autoWidth
                    options={[
                        {
                            label: <FormattedMessage id="Rules.level.mp" />,
                            value: RULE_STRING_FUNCTION_TYPES.MATCH_PATTERN,
                        },
                    ]}
                    value={levelValue.level1 || ''}
                    onChange={handleOnChange(1)}
                />
            ) : null}
            {levelValue.level1 ? (
                <PlainStringField value={levelValue.level2 || ''} onChange={handleOnChange(2)} />
            ) : null}
        </>
    );
};

export default UserAttributeRuleField;
